import dynamic from 'next/dynamic';
import css from './index.module.scss';
import BannerModule from '@/components/ProductDetailComponents/BannerModule';
import { useGlobal } from '@/utils/useGlobal';

const Content = dynamic(() => import('./dynamicContent'), {
    ssr: true,
});

export default function SolarPanel() {
    const { useLang } = useGlobal();
    const { t } = useLang('400wsolarpanel');
    const languageT = (value: string) => t(`solarpanels_400w.${value}`);
    const webpUrl = '/media/solarpanel_400w/pc/';

    const bannerData = [
        {
            bgImgs: ['1_banner.webp', '1_banner.jpg'],
            title: languageT('title'),
            des: languageT('des'),
        },
    ];

    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <div style={{ width: '100%', marginTop: '-64px' }}>
                <BannerModule data={bannerData} config={{ isShowLogo: false, webpUrl }} />
            </div>
            <Content />
        </div>
    );
}
